import { useEffect, useState } from "react";
import { useUIStore } from "../store/ui";

/** Whether the app is showing its dark palette (explicit mode, or the system's). */
export function useIsDark(): boolean {
  const theme = useUIStore((s) => s.theme);
  const [systemDark, setSystemDark] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(prefers-color-scheme: dark)").matches
      : false,
  );
  useEffect(() => {
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (e: MediaQueryListEvent) => setSystemDark(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  if (theme === "dark") return true;
  if (theme === "light") return false;
  return systemDark;
}
